import { predicates } from '../predicates/index';
import { selectors } from '../selectors/index';
import { TRAFFIC_SOURCES } from '../constants';

export const email = {
  rule: predicates.and(
    predicates.searchParamIncludesValue('utm_medium', 'email'),
    predicates.searchParamsIncludeKey('utm_source'),
  ),
  extractor: (traffic) => {
    const trafficSource = TRAFFIC_SOURCES.EMAIL;
    const trafficId = selectors.searchParamValue(traffic, 'utm_source');

    return {
      trafficSource,
      trafficId,
    };
  },
};
